import { render } from "./Masaza.vue?vue&type=template&id=03732997&scoped=true"
import script from "./Masaza.vue?vue&type=script&lang=js"
export * from "./Masaza.vue?vue&type=script&lang=js"

import "./Masaza.vue?vue&type=style&index=0&id=03732997&scoped=true&lang=css"
import "./Masaza.vue?vue&type=style&index=1&id=03732997&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03732997"]])

export default __exports__